/**
 * AddLocalizationCtrl controller
 * Add/edit localization
 */

import FileSaver from 'file-saver'

AddLocalizationCtrl.mixes = [
  'onOffCtrlMixin'
]

/**
 * AddLocalizationCtrl controller
 *
 * @class AddLocalizationCtrl
 * @memberof mwApp
 * @see mwApp/localization
 // * @mixes mwApp/common.mixin:m2mCtrlMixin
 *
 * @ngdoc controller
 * @name mwApp/localization.controller:AddLocalizationCtrl
 */
/* @ngInject */
export default function AddLocalizationCtrl ($scope, $location, $state, alertSvc, authSvc, Localization, localization, localizations, glossary) {
  var vm = this

  vm.app = $location.path().includes('client') ? 'client-apps' : 'scp'

  vm.view = !!$location.search().view
  vm.isNew = !localization.localization.locale?.tag
  vm.localizations = localizations
  vm.localization = localization
  vm.glossary = glossary
  vm.sampleLanguage = null

  // Create glossary data array for search functionality
  vm.updateGlossaryData = function () {
    vm.glossaryData = vm.glossary.map(key => ({
      key: key,
      get value () {
        return vm.localization.localization.dictionary[key] || ''
      }
    }))
  }

  // Initialize glossary data
  vm.updateGlossaryData()

  /**
   * Loader indicator
   *
   * @type {boolean}
   */
  $scope.loading = true

  vm.gettingAvailableLanguages = false

  /**
   * Save device
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   */
  vm.submit = function () {
    vm.setDisable()
    vm.emptyKeys = []
    vm.glossary.forEach(key => {
      if (!vm.localization.localization.dictionary[key]) {
        vm.emptyKeys.push(key)
      }
    })
    if (vm.emptyKeys.length) {
      alertSvc.alert(`Please fill all translations:\n${vm.emptyKeys.join(', ')}`, 'error')
      vm.unsetDisable()
      return
    }

    (vm.isNew ? Localization.save : Localization.update)(vm.localization).then(() => {
      alertSvc.alert(`${vm.localization.localization.locale.languageName} localization is ${vm.isNew ? 'created' : 'updated'}.`, 'success')
      vm.back()
    }).finally(vm.unsetDisable).catch(err => alertSvc.alert(err, 'error'))
  }

  vm.sampleValue = function (key) {
    if (vm.sampleLanguage?.localization.dictionary) {
      return vm.sampleLanguage.localization.dictionary[key]
    }
    return ''
  }

  if (authSvc.hasAccess('createLocalization')) {
    const networkId = vm.localization?.networkId
    Localization.getAvailableLanguages(vm.app, networkId)
      .then((result) => {
        vm.languages = result
      })
  }

  vm.choseSampleLanguage = function () {
    const networkId = vm.localization?.networkId
    const loadParams = { ...vm.sampleLanguage }
    if (networkId) {
      loadParams.networkId = networkId
    }
    Localization.loadLocale(loadParams).then(res => {
      vm.sampleLanguage = res
      if (!Object.keys(vm.localization.localization.dictionary).length) {
        vm.localization.localization.dictionary = vm.sampleLanguage.localization.dictionary
      }
      vm.updateGlossaryData()
    })
  }

  vm.downloadTranslations = function () {
    const escapeCsvValue = function (value) {
      if (value == null) return ''
      const stringValue = String(value)
      if (stringValue.includes(':') || stringValue.includes('"') || stringValue.includes('\n') || stringValue.includes('\r')) {
        return '"' + stringValue.replace(/"/g, '""') + '"'
      }
      return stringValue
    }

    let csvContent = ''

    vm.glossary.forEach(key => {
      const svcKey = escapeCsvValue(key)
      const value = escapeCsvValue(vm.localization.localization.dictionary[key])
      csvContent += `${svcKey}: ${value}\n`
    })

    const BOM = '\uFEFF'
    const blob = new Blob([BOM + csvContent], { type: 'text/csv;charset=utf-8;' })
    FileSaver.saveAs(blob, vm.localization.localization.locale.tag + '.csv')
  }

  vm.uploadTranslations = function (file, form) {
    try {
      // Парсим CSV файл в формате "key","value"
      const lines = file.split('\n')
      const uploadedTranslations = {}

      const parseCsvValue = function (str) {
        if (str == null) return ''

        str = String(str)
          .replace(/^\uFEFF/, '') // BOM
          .trim()
          .replace(/[\r\n]+$/g, '')

        if (str.length >= 2 && str[0] === '"' && str[str.length - 1] === '"') {
          str = str.substring(1, str.length - 1)
        }

        str = str.replace(/""/g, '"')

        return str
      }

      const parseCsvLine = function (line) {
        const result = []
        let current = ''
        let inQuotes = false
        let i = 0

        while (i < line.length) {
          const char = line[i]

          if (char === '"') {
            if (inQuotes) {
              if (i + 1 < line.length && line[i + 1] === '"') {
                current += '"'
                i += 2
                continue
              } else {
                let j = i + 1
                while (j < line.length && (line[j] === ' ' || line[j] === '\t')) {
                  j++
                }
                if (j >= line.length || line[j] === ',' || line[j] === '\r' || line[j] === '\n') {
                  inQuotes = false
                  i = j
                  continue
                } else {
                  current += '"'
                  i++
                  continue
                }
              }
            } else {
              inQuotes = true
              i++
              continue
            }
          }
          if (char === ':' && !inQuotes) {
            result.push(current)
            current = ''
            i++
            continue
          }
          current += char
          i++
        }
        if (current || result.length > 0) {
          result.push(current)
        }

        return result
      }
      lines.forEach(line => {
        const trimmedLine = line.trim()
        if (!trimmedLine) return
        const fields = parseCsvLine(trimmedLine)
        if (fields.length >= 2) {
          const key = parseCsvValue(fields[0])
          const value = parseCsvValue(fields[1])
          if (key) {
            uploadedTranslations[key] = value
          }
        }
      })

      if (Object.keys(uploadedTranslations).length > 0) {
        vm.localization.localization.dictionary = uploadedTranslations
        form.$pristine = false
        vm.updateGlossaryData()
      } else {
        alertSvc.alertError('No valid translations found in the file.')
      }
    } catch (error) {
      alertSvc.alertError('Error parsing translations file: ' + error.message)
    }
  }

  /**
   * Delete Language
   *
   * @memberOf mwApp/localizations.controller:AddLocalizationCtrl
   */
  vm.delete = function () {
    vm.setDisable()
    vm.localization._delete()
      .then(() => {
        const networkId = vm.localization?.networkId
        const appName = vm.localization.appName || vm.app

        if (networkId) {
          const tabState = appName === 'scp'
            ? 'app.organizations.organization.appLocalization.application'
            : 'app.organizations.organization.appLocalization.client'

          return $state.go(tabState, { packageId: networkId })
        }

        return vm.location(vm.localization).list()
      })
      .finally(vm.unsetDisable)
  }

  /**
   * Redirect to previous page
   *
   * @memberof mwApp/devices.controller:AddDeviceCtrl
   */
  vm.back = function () {
    if (vm.location.canPop()) {
      vm.location.back()
    } else {
      const networkId = vm.localization?.networkId
      const appName = vm.localization.appName || vm.app

      if (networkId) {
        const tabState = appName === 'scp'
          ? 'app.organizations.organization.appLocalization.application'
          : 'app.organizations.organization.appLocalization.client'

        $state.go(tabState, { packageId: networkId })
      } else {
        $location.url(`app-localization#${appName === 'scp' ? 'applications' : 'clients'}`)
      }
    }
  }
}
